import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-service-type';
const API_DETAIL = (id: number) => `/p-crm-service-type/${id}`;

export interface ServiceType {
  id: number;
  pst_descr?: string;
  pst_color?: string;
}

export const useServiceTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<ServiceType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    serviceTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useServiceType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<ServiceType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    serviceType: data,
    isLoading,
    isError: error,
    mutate,
  };
};
